module.exports = "https://trybtryb-legacy.web.app/img/lock-icon.698f75b8.png";